import {createFeatureSelector, createSelector} from '@ngrx/store';
import {SettingsState} from './settings.reducer';

const selectSettingsState = createFeatureSelector<SettingsState>('settings');

export const selectMode = createSelector(
    selectSettingsState,
    (state: SettingsState) => state.mode
);

export const selectCharacterId = createSelector(
    selectSettingsState,
    (state: SettingsState) => state.character
);
